
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
export interface PromotionModel {
    products: ProductModel[]
}

export interface PromotionParameter extends ApiParameter {
    promotionId?: string;
}

const PromotionUrl = "api/v2/choiceoffreeproducts";

export async function choiceOfFreeProducts(
    parameter: PromotionParameter,
) {
    const response = await get<PromotionModel>(`${PromotionUrl}`, parameter);
    return response;
}
